var map = {
	"./pages/auth/auth.module": [
		"./src/app/pages/auth/auth.module.ts",
		"pages-auth-auth-module"
	],
	"./pages/canvas/canvas.module": [
		"./src/app/pages/canvas/canvas.module.ts",
		"default~pages-canvas-canvas-module~pages-dashboard-dashboard-module~pages-results-results-module",
		"default~pages-canvas-canvas-module~pages-tests-tests-module",
		"common",
		"pages-canvas-canvas-module"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"default~pages-canvas-canvas-module~pages-dashboard-dashboard-module~pages-results-results-module",
		"common",
		"pages-dashboard-dashboard-module"
	],
	"./pages/error/error.module": [
		"./src/app/pages/error/error.module.ts",
		"pages-error-error-module"
	],
	"./pages/options/options.module": [
		"./src/app/pages/options/options.module.ts",
		"pages-options-options-module"
	],
	"./pages/register/register.module": [
		"./src/app/pages/register/register.module.ts",
		"pages-register-register-module"
	],
	"./pages/results/results.module": [
		"./src/app/pages/results/results.module.ts",
		"default~pages-canvas-canvas-module~pages-dashboard-dashboard-module~pages-results-results-module",
		"common",
		"pages-results-results-module"
	],
	"./pages/tests/tests.module": [
		"./src/app/pages/tests/tests.module.ts",
		"default~pages-canvas-canvas-module~pages-tests-tests-module",
		"common",
		"pages-tests-tests-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;